<template>
    <div>
        <!-- <div v-for="(n, index) in contents" :key="index + 'management'">
            <p class="subheading mb-0">
                <a :href="`#/${$route.params.category}/${$route.params.contentType}/${n.ID}`" v-if="n.ID" v-html="n.Title"></a>
                <a :href="n.link" v-else v-html="n.Title"></a>
            </p>
            <p class="caption grey--text">{{n.Date | moment("DD-MM-YYYY")}}</p>
            <v-divider class="mb-4" v-if="index != (contentItem.length - 1)"></v-divider>
        </div> -->
        <v-row>
            <v-col cols="12" sm="6" md="4" v-for="(n, index) in contents"   :key="index">
                <v-card flat color="blue lighten-5">
                    <v-card-text style="min-height: 92px;">
                        <p class="box-title px-1" style="font-family: 'Mv Eamaan XP' !important;"><a :href="`#/${$route.params.category}/${$route.params.contentType}/${n.ID}`" >{{n.Title}}</a></p>
                    </v-card-text>
                    <v-card-text>
                        <p class="caption ma-0">{{n.Date | moment("DD-MM-YYYY")}}</p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    export default {
        props: ['contents']
    }
</script>